<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'app.dashboard.select_farm.title' | i18n }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-searchbar
    (ionInput)="onSearchChange($event)"
    [placeholder]="'app.dashboard.select_farm.searchFarm' | i18n"
    debounce="300"
    show-clear-button="always"
  ></ion-searchbar>
  <ion-list lines="none">
    <ion-item-group *ngFor="let client of clientFarms">
      <ion-label class="client-header" color="medium">{{ client.client.clientName }}</ion-label>
      <ion-item
        button
        *ngFor="let farm of client.farms"
        (click)="onSelect(farm.farmId)"
        [ngClass]="{ 'selected-farm': farmState.get()?.farmId == farm.farmId }"
      >
        <ion-label>{{ farm.farmName }}</ion-label>
        <ion-icon *ngIf="farmState.get()?.farmId == farm.farmId" name="checkmark-circle" slot="end"></ion-icon>
      </ion-item>
      <br />
    </ion-item-group>
  </ion-list>
</ion-content>
